<template>
  <div class="news-content-container">
    <back-open-chenter />
    <div class="news-content-panel">
      <div class="news-title">「第四届Light技术公益创造营」获评 2024 中国最受开发者欢迎的技术活动</div>
      <div class="news-date">2025年1月6日</div>
      <div class="news-content">
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/ai_logo.gif"/>
          </div>
        </div>
        <p>
          1 月 6 日，中国技术先锋年度评选丨2024 中国最受开发者欢迎的技术活动榜单正式发布。
          <span class="mark-text highlight">Light 技术公益创造营作为国内最具影响力的技术公益平台之一，成功入选该榜单。</span>
          作为中国领先的新一代开发者社区，SegmentFault 思否依托社区活动板块（https://segmentfault.com/events）及全站上千万开发者用户数据分析及活动规模、内容好评度、行业综合影响力指标，最终评选出了30个全年最受开发者欢迎的技术活动。
        </p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/newscenter/news73.webp"/>
          </div>
        </div>
        <p>第四届Light技术公益创造营由中国宋庆龄青少年科技文化交流中心、腾讯公益慈善基金会联合主办，腾讯技术公益、腾讯云智能、腾讯优图实验室协办，聚焦“儿童素养教育、社区公益、生态环保”三大议题，号召科研和技术志愿者、社会组织和企业、热心公益人士等，共同打造技术公益解决方案。 </p>
        <p>
          <span class="mark-text highlight">Light技术公益创造营自2020年启动以来，已经吸引了近5000支队伍、超20000名开发者参与</span>
          ，成为中国最具影响力的技术公益平台之一，为技术公益注入了可持续发展的新活力。
        </p>
        <p>未来，我们也将继续打磨产品和技术，为开发者持续输送“弹药”，释放技术公益的内核价值，并吸引社会各界对公益事业的关注和参与，共同解决更多的社会公共议题。期待Light与广大开发者共同成长，让科技与公益碰撞更多火花。</p>
      </div>
    </div>
  </div>
</template>

<script>
import BackOpenChenter from '@/components/open/panels/news/detail/BackOpenChenter';
export default {
  name: 'News67',
  components: {
    BackOpenChenter
  }
};
</script>

<style lang="less" scoped>
@import "./news.less";
.news-content {
  margin: 0 auto;
  .image-panel {
    max-width: 667px;
    text-align: center;
    img {
      max-width: 667px;
    }
    span {
      font-size: 12px;
      color: #858585;
    }
  }
  .highlight {
    color: #0052FF;
  }
  .end-divide {
    width: 120px;
    height: 2px;
    margin: 20px auto;
    background: #0152d9;
  }
  .download-article-wrap {
    margin: 0 auto;
    padding: 5px 3px;
    border: 3px solid rgb(1, 82, 217);
    font-family: PingFangSC-light;
    .download-article {
      padding: 5px 10px;
      border-left: 1px solid rgb(1, 82, 217);
      border-right: 1px solid rgb(1, 82, 217);
    }
  }
  .right-text {
    font-size: 12px;
    text-align: right;
    color: #0152d9;
  }
  .news-literature {
    max-height: 180px;
    padding: 15px;
    overflow-y: scroll;
    background-color: #ebebeb;
  }
  .short-center{
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/open/panels/news/detail/News73.vue